export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12045.9595b546.jpg";